import { Component, Input } from "@angular/core";

@Component({
    selector:'logo-heading-component',
    templateUrl:'./logo-heading.component.html',
    styleUrls:['./logo-heading.component.scss']
})
export class LogoHeadingComponent {
    @Input() titleDescription:string|any;
}